module.exports = __webpack_public_path__ + "img/chevron-down.f13d7069.svg";